import React, { useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import ServicePricing from './ServicePricing';
import About from './About';
import Gallery from './Gallery';
import Contact from './Contact';
import Footer from './Footer';
import './Home.css';

const Home: React.FC = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <div className="home-container">
      <Header />
      <Hero />
      <Services />
      <ServicePricing />
      <Gallery />
      <About />
      <Contact />
      <Footer />
      
      <div className="quick-contact">
        <button 
          className="quick-contact-toggle"
          onClick={() => setIsContactOpen(!isContactOpen)}
          aria-label="Rychlý kontakt"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
          </svg>
        </button>
        {isContactOpen && (
          <div className="quick-contact-popup">
            <div className="quick-contact-header">
              <h3>Rychlý kontakt</h3>
              <button 
                className="quick-contact-close"
                onClick={() => setIsContactOpen(false)}
                aria-label="Zavřít"
              >
                ×
              </button>
            </div>
            <div className="quick-contact-content">
              <a href="tel:+420777821756" className="quick-contact-phone">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
                </svg>
                777 821 756
              </a>
              <a href="mailto:smrxa@smrxashop.cz" className="quick-contact-email">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                </svg>
                smrxa@smrxashop.cz
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;

